import styled from "styled-components";

export const Container = styled.div`
  width: 450px;
  margin-bottom: 40px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SubtitleContainer = styled.div`
  margin-top: 10px;
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const ButtonContainer = styled.div`
  display: flex;

  width: 100px;

  &:not(:last-child) {
    margin-right: 30px;
  }
`;
